import React from 'react'
import { NewChatBtnText } from '../../../NewConstants/NewChatConstants'
const NewChatBtn = ({ selectedLanguage, onClick = () => {}, disabled = false }) => {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      className={`h-[3.063rem] flex items-center justify-center gap-2 bg-[var(--neutral-white)] rounded-xl py-3 px-[13px] text-[var(--system-blue)] font-medium ${
        disabled ? "opacity-60 pointer-events-none" : "cursor-pointer"
      }`}
    >
        <img src="/Assets/Images/ArrowClockwise.svg" alt="" />
        <span>{NewChatBtnText[selectedLanguage]}</span>
    </div>
  )
};

export default NewChatBtn;